import { useEffect, useRef } from "react";

export default function AdsBanner() {
  const adRef = useRef(null);

  useEffect(() => {
    if (!adRef.current) return;

    // Load AdSense ONLY if the <ins> hasn't been initialized
    if (!adRef.current.getAttribute("data-adsbygoogle-status")) {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {
        console.error("Adsense error:", e);
      }
    }

  }, []);

  return (
    <ins
      ref={adRef}
      className="adsbygoogle"
      style={{ display: "block", textAlign: "center" }}
      data-ad-client="ca-pub-4046916434736376"
      data-ad-slot="6124729683"
      data-ad-format="auto"
      data-full-width-responsive="true"
    ></ins>
  );
}
